<script>
    import { IDLE, INCALL, OUTCALL } from 'common/callState';
    import { formatDuration } from 'services/utils';
    import { createEventDispatcher } from 'svelte';
    import ButtonBase from '../common/ButtonBase.svelte';
    import Icon from '../components/Icon.svelte';
    import callStore from 'store/call';

    const dispatch = createEventDispatcher();

    let notes;
    export let peer_name;

    let loundSpeaker = false;
    let microphone = true;
    
    const saveNote = (notes) => {
        if ($callStore.state === INCALL || $callStore.state === OUTCALL) {
            callStore.update({
                notes
            });
        }
    };

    const toggleMute = () => {
        microphone = !microphone;
        dispatch('mute');
    };

    const hangup = () => {
        dispatch('hangup');
    };
</script>

<div id="take-note" class="row content">
    <div
        class="ongoing-call"
        style={$callStore.state !== IDLE ? 'background: #4aaf57;' : 'background: #ef3333;'}
    >
        <div class="call-info">
            <span class="caller-name color-white">{peer_name}</span>
            <span class="time">{formatDuration($callStore.duration)}</span>
        </div>

        <div class="ongoing-call-ations">
            <!-- <div class="note-icon-bg">
                <Icon
                    icon="loundspeaker"
                    color="#FFFFFF"
                    on:click={() => (loundSpeaker = !loundSpeaker)}
                />
            </div> -->
            <ButtonBase
                on:click={toggleMute}
                disabled={$callStore.state !== INCALL && $callStore.state !== OUTCALL}
            >
                <div class="note-icon-bg">
                    <Icon
                        icon={microphone ? 'microphone-mute' : 'microphone'}
                        color="#FFFFFF"
                    />
                </div>
            </ButtonBase>

            <ButtonBase on:click={hangup}>
                <div class="note-icon-bg" style={'background: #FFFFFF;'}>
                    <Icon icon="end-call" color="#EF3333" />
                </div>
            </ButtonBase>
        </div>
    </div>
    <section class="display-flex">
        <div class="note-body">
            <textarea placeholder="Type something" bind:value={notes} />

            <button class="button" on:click={saveNote}>Save Note</button>
        </div>
    </section>
</div>

<style lang="scss">
    #take-note {
        .ongoing-call {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            background: #4aaf57;
            padding: 0 1.5em;
            .call-info {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                padding: 12px 0;
                .color-white {
                    color: #ffffff;
                }
                .time {
                    font-family: 'Urbanist';
                    font-style: normal;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 140%;
                    color: #fafafa;
                }
            }
            .ongoing-call-ations {
                display: flex;
                gap: 16px;
                padding: 8px 0;
                .note-icon-bg {
                    width: 44px;
                    height: 44px;
                    background: rgba(17, 44, 32, 0.28);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
        section {
            margin: 0 2.25rem;
            .button {
                width: 100%;
            }
            .note-body {
                padding-top: 1.25rem;
                width: 100%;
            }

            textarea {
                width: 100%;
                height: 366px;
                border: none;
                outline: none;
                color: #a7b4be;
                font-family: inherit;
                font-size: inherit;
                margin: 0 0 0.5em 0;
                box-sizing: border-box;
            }
        }
    }
</style>
